export default function Positioning() {
  const pillars = [
    {
      title: 'Creative',
      icon: 'ri-palette-line',
      color: 'from-green-400 to-emerald-500',
      items: [
        'Inclusive, beginner-friendly',
        'No dance experience required',
        'Focus on expression and flow'
      ]
    },
    {
      title: 'Holistic',
      icon: 'ri-heart-pulse-line',
      color: 'from-orange-400 to-orange-600',
      items: [
        'Movement meditation',
        'Wellness and balance',
        'Mind–body integration'
      ]
    },
    {
      title: 'Tech-Driven',
      icon: 'ri-cpu-line',
      color: 'from-cyan-400 to-blue-500',
      items: [
        'Unreal Engine environments',
        'AI-guided missions',
        'Real-time feedback'
      ]
    }
  ];

  return (
    <section id="overview" className="py-32 bg-[#0A0A0F]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="font-serif text-5xl md:text-6xl font-bold text-white text-center mb-6">
          Not a Team Building. Not a Dance Class.
        </h2>
        <p className="text-amber-400 text-xl md:text-2xl text-center mb-20">
          A Creative Harmony Experience.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {pillars.map((pillar, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-b from-[#1A1A2E] to-[#0F0F1A] rounded-3xl p-10 hover:-translate-y-2 hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${pillar.color} flex items-center justify-center mb-8 mx-auto group-hover:rotate-6 transition-transform duration-300`}>
                <i className={`${pillar.icon} text-4xl text-white`}></i>
              </div>
              
              <h3 className="text-3xl font-bold text-white text-center mb-8">
                {pillar.title}
              </h3>

              <ul className="space-y-5">
                {pillar.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-4">
                    <div className={`w-3 h-3 rounded-full bg-gradient-to-br ${pillar.color} mt-2 flex-shrink-0`}></div>
                    <span className="text-gray-300 text-lg leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-2xl text-cyan-400 font-light italic">
            Groove &amp; Glow is designed for creativity, wellbeing and connection — not competition.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            See How It Works
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
